import classNames from 'classnames';
import { CirclePicture, Icon, FlexContainer, InputFile } from 'components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useProfile } from 'state';
import styles from './EditProfilePicture.module.scss';

/**
 * EditProfilePicture
 *
 * @return {JSX.Element}
 */
const EditProfilePicture = ({ className }) => {
  const profileState = useProfile();
  const [isLoading, setIsLoading] = useState(false);
  const [, setError] = useState('');

  const handleImage = async ({ target: { files } }) => {
    if (files && files.length) {
      setIsLoading(true);
      try {
        console.log('Updating...');
        await profileState.updateProfilePicture(files[0]);
        console.log('Updated');
        setIsLoading(false);
      } catch (e) {
        console.log('Error', e.message);
        setIsLoading(false);
        setError(e.message);
      }
    }
  };

  return (
    <FlexContainer
      className={classNames(
        styles.EditProfilePicture,
        isLoading && styles.EditProfilePicture__loading,
        className,
        `${EditProfilePicture.displayName}`
      )}
      justifyContentCenter
    >
      <InputFile
        className={styles.ProfilePictureInput}
        onChange={handleImage}
        useDrag
        accept="image/jpeg,image/png"
        disabled={isLoading}
      >
        <CirclePicture
          className={styles.ProfilePicture}
          src={profileState.data.imageUrl}
          fullText={`${profileState.data.firstName} ${profileState.data.lastName}`}
          isLoading={isLoading}
          reverse
        />
        <FlexContainer
          className={styles.IconsContainer}
          alignCenter
          justifyContentCenter
        >
          {isLoading ? null : (
            <Icon name="edit" highlight="black" className={styles.Icon} />
          )}
        </FlexContainer>
      </InputFile>
    </FlexContainer>
  );
};

EditProfilePicture.displayName = 'EditProfilePicture';

export default observer(EditProfilePicture);
